// extracted by mini-css-extract-plugin
module.exports = {"btAction":"SnackMoons_btAction__1rq9Y"};